KMVP.masterCarts = {

    // TODO eliminate duplicated code

    poolingRequestInterval: 5000,
    pricingWaitPeriod: 0,
    sleepPeriod: 1000,
    calculationInformationBoxSelector: '.popup-price-request-info',
    inProgressSpinner: $("<img src='" + ACC.config.resource.spinner + "' />"),

    bindNewMasterCartBtnPDP: function () {
        $('.js-new-mastercart-pdp').on('click', function () {
            var addToCartForm = $(this).closest('.add_to_cart_form');

            $.colorbox({
                innerWidth: '450px',
                href: $(this).data('url'),
                scrolling: true,
                onComplete: function () {
                    // bind cancel and ajaxForm Events
                    KMVP.masterCarts.addCreateAddToCartEvents(addToCartForm);
                }
            });
            $.colorbox.resize();

        });

        $('.js-add-to-cart-button-dropdown-pdp .dropdown-menu-item:not(:last-child)').on('click', function () {
            //set value to hidden input
            var targetCartCode = $(this).closest('.add_to_cart_form').find('.targetCartCode');
            targetCartCode.val($(this).data('cartcode'));

            $('#addToCartButton').click();

            // Reset value.
            targetCartCode.val('');
        });
    },

    /**
     * Bind Click Event and open Colorbox to create a new cart (shared or private)
     */
    bindNewMasterCartBtn: function () {
        var $newMasterCartBtn = $('.js-new-mastercart');

        if (!$newMasterCartBtn) {
            return false;
        }
        $newMasterCartBtn.on('click', function () {
            var addToCartForm = $(this).closest('.add_to_cart_form');

            $.colorbox({
                innerWidth: '450px',
                href: $(this).data('url'),
                scrolling: true,
                onComplete: function () {
                    // bind cancel and ajaxForm Events
                    KMVP.masterCarts.addCreateEvents(addToCartForm);
                }
            });
            $.colorbox.resize();
        });
    },
    addCreateEvents: function (addToCartForm) {
        $('.js-cart-cancel').on('click', function (e) {
            e.preventDefault();
            $.colorbox.close();
        });

        $('.js-create-mastercart-form').ajaxForm({
            success: function (data) {
                window.location.reload();
            },

            error: function (data) {
                $.colorbox({
                    innerWidth: '450px',
                    innerHeight: '290px',
                    html: data.responseText
                });
                KMVP.masterCarts.addCreateEvents(addToCartForm);
            }
        });
    },
    addCreateAddToCartEvents: function (addToCartForm) {
        $('.js-cart-cancel').on('click', function (e) {
            e.preventDefault();
            $.colorbox.close();
        });

        $('.js-create-mastercart-form').ajaxForm({
            success: function (data) {

                var cartCode = JSON.parse(data);
                if (cartCode.masterCartCode) {
                    var dropdownMenuOnCart = $(".addToCartButton-wrapper .js-add-to-cart-button-dropdown-cart");
                    var dropdownMenuOnPdp = $(".addToCartButton-wrapper .js-add-to-cart-button-dropdown-pdp");

                    // Check if we are on pdp.
                    if (dropdownMenuOnPdp.length > 0) {
                        //set value to hidden input
                        var targetCartCode = addToCartForm.find('.targetCartCode');
                        targetCartCode.val(cartCode.masterCartCode);

                        $('#addToCartButton').click();

                        // Reset value.
                        targetCartCode.val('');
                    }

                    $.colorbox.close();

                    var sourceCartCode = dropdownMenuOnCart.data('sourcecartcode');
                    var entryNumber = dropdownMenuOnCart.data('entrynumber');
                    var url = dropdownMenuOnCart.data('url');

                    $.get(ACC.cart.addToCartDropdownUrl, {
                            "sourceCartCode": sourceCartCode,
                            "entryNumber": entryNumber,
                            "url": url
                        }
                        ).done(function (data) {
                        var dropdownMenu = $(".addToCartButton-wrapper .dropdown-menu");
                        dropdownMenu.empty();
                        dropdownMenu.append(data);
                        KMVP.masterCarts.initialize();

                        if (dropdownMenuOnCart.length > 0) {
                            $(".js-add-to-cart-button-dropdown-cart li[data-cartcode='" + cartCode.masterCartCode + "']").click();
                        }
                    });
                }
            },
            error: function (data) {
                $.colorbox({
                    innerWidth: '450px',
                    innerHeight: '290px',
                    html: data.responseText
                });
                KMVP.masterCarts.addCreateAddToCartEvents(addToCartForm);

            }
        });

    },
    bindCartDropDown: function () {
        var addToCartFunction = function () {
            $.ajax({
                async: false,
                type: "POST",
                dataType: 'json',
                contentType: 'application/json',
                url: $(this).attr('data-url'),
                data: JSON.stringify({
                    entryNumber: $(this).data('entrynumber'),
                    sourceCartCode: $(this).data('sourcecartcode'),
                    targetCartCode: $(this).data('cartcode')
                }),
                success: function (data, status) {
                    window.location.reload();
                }
            });
        };
        $('.js-add-to-cart-button-dropdown-cart .dropdown-menu-item:not(:last-child)').on('click', addToCartFunction);
        $('.js-add-to-quotecart-cart').on('click', addToCartFunction);
    },
    bindDeleteMasterCartLink: function () {
        $('.js-cart-delete-link').on('click', function (e) {
            e.preventDefault();
            $.colorbox({
                innerWidth: '450px',
                href: $(this).data('url'),
                scrolling: true,
                onComplete: function () {
                    // bind cancel and ajaxForm Events
                    KMVP.masterCarts.addDeleteEvents();
                }
            });
            $.colorbox.resize();
        });
    },
    addDeleteEvents: function () {
        $('.js-cart-delete-cancel').on('click', function (e) {
            e.preventDefault();
            $.colorbox.close();
        });

        $('.js-cart-delete').on('click', function (e) {
            $.ajax({
                url: $(this).data('url'),
                type: 'DELETE',
                success: function (result) {
                    // Do something with the result
                    window.location.reload();
                },
                error: function (result) {
                    // do something
                    $.colorbox.close();
                }
            });
        });

    },
    bindUpdateMasterCartLink: function () {
        $('.js-cart-update-link').on('click', function (e) {
            e.preventDefault();
            $.colorbox({
                innerWidth: '450px',
                href: $(this).data('url'),
                scrolling: true,
                onComplete: function () {
                    // bind cancel and ajaxForm Events
                    KMVP.masterCarts.addUpdateEvents();
                }
            });
            $.colorbox.resize();
        });
    },
    addUpdateEvents: function () {
        $('.js-cart-update-cancel').on('click', function (e) {
            e.preventDefault();
            $.colorbox.close();
        });

        $('.js-update-mastercart-form').ajaxForm({

            success: function (data) {
                window.location.reload();
            },
            error: function (data) {
                $.colorbox({
                    innerWidth: '450px',
                    innerHeight: '290px',
                    html: data.responseText
                });
                KMVP.masterCarts.addUpdateEvents();
            }
        });
    },
    bindMasterCartApproveBtn: function () {
        $('.js-cart-approve-link').on('click', function (e) {
            e.preventDefault();
            $.colorbox({
                fixed: true,
                innerWidth: '550px',
                href: $(this).data('url'),
                scrolling: true,
                onComplete: function () {
                    // bind cancel and ajaxForm Events
                    KMVP.masterCarts.addCartApproveEvents();
                    KMVP.masterCarts.bindApproverHandling();
                    $.colorbox.resize();
                }
            });
        });

    },
    addCartApproveEvents: function () {
        $('.js-cart-cancel').on('click', function (e) {
            e.preventDefault();
            $.colorbox.close();
        });

        $('.js-cart-approve-form').ajaxForm({
            success: function (data) {
                window.location.reload();
            },

            error: function (data) {
                $.colorbox({
                    innerWidth: '550px',
                    innerHeight: '520px',
                    html: data.responseText
                });
                KMVP.masterCarts.addCartApproveEvents();
            }
        });
    },
    bindMasterCartEditBtn: function () {
        $('.js-cart-edit-link').on('click', function (e) {
            e.preventDefault();
            $.colorbox({
                innerWidth: '550px',
                href: $(this).data('url'),
                scrolling: true,
                onComplete: function () {
                    // bind cancel and ajaxForm Events
                    KMVP.masterCarts.addCartEditEvents();
                    $.colorbox.resize();
                }
            });
        });

    },
    addCartEditEvents: function () {
        $('.js-cart-cancel').on('click', function (e) {
            e.preventDefault();
            $.colorbox.close();
        });

        $('.js-cart-edit-form').ajaxForm({
            success: function (data) {
                window.location.reload();
            },

            error: function (data) {
                $.colorbox({
                    innerWidth: '550px',
                    innerHeight: '520px',
                    html: data.responseText
                });
                KMVP.masterCarts.addCartEditEvents();
            }
        });
    },

    bindApproverHandling: function () {
        $('.js-cart-approver-list').on('click', function (e) {
            if ($(e.target).hasClass('js-cart-approver') || $(e.target).children().hasClass('js-cart-approver')) {
                $('.js-cart-all-approvers-input').prop('checked', false);
            } else if ($(e.target).hasClass('js-cart-all-approvers') || $(e.target).children().hasClass('js-cart-all-approvers')) {
                $('.js-cart-approver-input').prop('checked', false);
            }
        });
    },
    bindMoveCartEntryToQuoteRequest: function () {
        $('.js-add-to-request-notebook-btn').on('click', function (e) {
            var entrynum = $(this).attr('data-cart-entry');
            $.ajax({
                async: false,
                type: "POST",
                dataType: 'json',
                contentType: 'application/json',
                url: $(this).attr('data-url'),
                data: JSON.stringify({
                    entryNumber: $(this).data('cart-entry'),
                    sourceCartCode: $(this).data('cartcode')
                }),
                success: function (data, status) {
                    $('#add-to-request-notebook-label-' + entrynum).removeClass('d-none');
                    $('#add-to-request-notebook-btn-' + entrynum).addClass('d-none');
                }
            });
        });
    },

    bindCopyCartEntriesToQuoteRequest: function () {
        $('.js-copy-cart-entries-to-request').on('click', function (e) {
            e.preventDefault();
            $.ajax({
                type: "POST",
                dataType: 'json',
                contentType: 'application/json',
                url: $(this).attr('data-url'),
                data: JSON.stringify({
                    sourceCartCode: $(this).data('cartcode')
                }),
                success: function (data) {
                    $(".js-header .js-container").append(htmlDecode(data.addToCartLayer));

                    $('.js-add-to-cart-layer').fadeIn(function(){
                        $.colorbox.close();
                        if (typeof timeoutId != 'undefined') {
                            clearTimeout(timeoutId);
                        }
                        timeoutId = setTimeout(function () {
                            $('.js-add-to-cart-layer').fadeOut(function(){
                                $(this).remove();
                            });
                        }, 5000);
                    });

                    if (typeof data.cartData.totalItems !== "undefined") {
                        if (typeof ACC.minicart.refreshMiniCartCount == 'function') {
                            ACC.minicart.refreshMiniCartCount(data.cartData.cartType, data.cartData.totalItems);
                        }
                    }
                }
            });
        });
    },

    bindOnClickOnCancelButton: function () {
        $('.js-cancel-popup').on('click', function (e) {
            e.preventDefault();
            $.colorbox.close();
        });
    },

    bindRequestPricesButton: function () {
        var requestPricesButton = $('.js-request-prices-button');
        var form = $('#js-request-prices-form');

        requestPricesButton.on('click', function (e) {
            e.preventDefault();
            $(this).prop("disabled", true);
            $('.js-price-request-in-progress-hint').removeClass('hide');
            $('.js-price-request-calculation-error').addClass('hide');

            requestPricesButton.showSpinner();
            $.ajax({
                url: form.attr("action"),
                data: form.serialize(),
                type: form.attr("method").toUpperCase(),
                success: function () {
                    setTimeout(KMVP.masterCarts.isCalculateOrRecalculateForSessionCartInProgressChecker, KMVP.masterCarts.poolingRequestInterval, form);
                }
            });
        });

        if (requestPricesButton.data('calculateorrecalculateinprogress') === true) {
            setTimeout(KMVP.masterCarts.isCalculateOrRecalculateForSessionCartInProgressChecker, KMVP.masterCarts.poolingRequestInterval, form);
        }
    },

    isCalculateOrRecalculateForSessionCartInProgressChecker: function (elem) {

        $.ajax({
            url: elem.data('pollingurl'),
            dataType: 'json',
            data: {
                waitPeriod: KMVP.masterCarts.pricingWaitPeriod
            },
            type: 'POST',
            success: function (pollingResultData) {
                if (!pollingResultData || !pollingResultData.status) {
                    return;
                }

                var priceInfoPopup = $(KMVP.masterCarts.calculationInformationBoxSelector);
                if (typeof priceInfoPopup != 'undefined') {
                    $(priceInfoPopup).data('status', pollingResultData.status);
                }

                if (pollingResultData.status === 'READY') {
                    KMVP.masterCarts.showCartCalculationInfoBox();
                    setTimeout(function () {window.location.href = elem.data('carturl');},  KMVP.masterCarts.sleepPeriod);
                    return;
                }

                if (pollingResultData.status === 'ERROR') {
                    KMVP.masterCarts.calculationFailed();
                    return;
                }

                if (pollingResultData.status === 'NOT_READY') {
                    KMVP.masterCarts.pricingWaitPeriod = pollingResultData.waitPeriod + KMVP.masterCarts.poolingRequestInterval;
                    setTimeout(KMVP.masterCarts.isCalculateOrRecalculateForSessionCartInProgressChecker, KMVP.masterCarts.poolingRequestInterval, elem);
                } else {
                    KMVP.masterCarts.calculationFailed();
                    KMVP.masterCarts.showCartCalculationInfoBox();
                }
            }
        });
    },

	calculationFailed: function () {
		var requestPricesButton = $('.js-request-prices-button');

		$('.js-price-request-calculation-error').removeClass('hide');
		$('.js-price-request-in-progress-hint').addClass('hide');
		requestPricesButton.prop("disabled", false);
		requestPricesButton.hideSpinner();

        // If we are show the price-popup, we redirect to the cart
        if ($(KMVP.masterCarts.calculationInformationBoxSelector).length > 0) {
            setTimeout(function () {
                window.location.href = ACC.cart.showPricingError;
            }, 2000);
        }
	},

	checkAndTriggerCartCalculationOnSummaryPage: function () {
       var form = $('#js-request-prices-form');
       var calcInfo = $(KMVP.masterCarts.calculationInformationBoxSelector);
       if (typeof form == 'undefined') {return;}
	   if (!form.data('cartcalculationrequired') === true) {
	       return;
	   }

	   if (form.data('calculated') === true) {
	       return;
	   }

	   calcInfo.data('status', 'NOT_READY');
       KMVP.masterCarts.showCartCalculationInfoBox();
       if (form.data('calculateorrecalculateinprogress') === true) {
            setTimeout(KMVP.masterCarts.isCalculateOrRecalculateForSessionCartInProgressChecker, KMVP.masterCarts.poolingRequestInterval, form);
            return;
       }
       $.ajax({
            type: "post",
            url: form.attr("action"),
            data: form.serialize(),
            success: function(result) {
                setTimeout(KMVP.masterCarts.isCalculateOrRecalculateForSessionCartInProgressChecker, KMVP.masterCarts.poolingRequestInterval, form);
            },
            error: function (data) {
                calcInfo.data('status', 'ERROR');
                KMVP.masterCarts.showCartCalculationInfoBox();
                setTimeout(function () {window.location.href = elem.data('carturl');}, 3000);
            }
       });

    },

    showCartCalculationInfoBox : function () {
        var calcInfo = $(KMVP.masterCarts.calculationInformationBoxSelector);
        $(calcInfo).click(function () {
                $(calcInfo).colorbox({
                        open: true,
                        inline: true,
                        href: $(calcInfo)[0],
                        transition: "none",
                        scrolling: false,
                        escKey: false,
                        overlayClose: false,
                        height: false,
                        onClosed: function () {
                            $(calcInfo).hide();
                            $.colorbox.resize();
                        },
                        onLoad: function() {
                                $('#cboxClose').remove();
                            },
                        onComplete: function () {
                                $(this).colorbox.resize({innerWidth:"890px", innerHeight:"440px"});
                                $(calcInfo).removeClass('hide');
                                var status = $(calcInfo).data('status');
                                if (status === 'NOT_READY') {
                                   $('.js-price-request-calculation-successful').addClass('hide');
                                   $('.js-price-request-calculation-error').addClass('hide');
                                   $(".price-request-hint-spinner").html(KMVP.masterCarts.inProgressSpinner);
                                   $(".js-price-request-in-progress-hint").removeClass('hide');

                                } else if (status === 'READY') {
                                    $('.js-price-request-calculation-successful').removeClass('hide');
                                    $('.js-price-request-in-progress-hint').addClass('hide');
                                    $('.js-price-request-calculation-error').addClass('hide');
                                } else {
                                    $('.js-price-request-calculation-successful').addClass('hide');
                                    $('.js-price-request-calculation-hint').addClass('hide');
                                    $('.js-price-request-calculation-error').removeClass('hide');
                                    setTimeout(KMVP.masterCarts.closeCartCalculationInfoBox,KMVP.masterCarts.poolingRequestInterval);
                                }

                                $(".js-price-request-cancel").on("click", function () {
                                    KMVP.masterCarts.closeCartCalculationInfoBox();
                                });
                            }
                });

        });
        KMVP.individualDelivery.storeDkgTelAvisData();
        //open popup with delay to prevent closing it by "$.colorbox.close();" called in some other js
        setTimeout(function() {$(calcInfo).click()},10);
    },

    closeCartCalculationInfoBox : function () {
        $(KMVP.masterCarts.calculationInformationBoxSelector).colorbox.close();
        $(KMVP.masterCarts.calculationInformationBoxSelector).hide();
    },

    initialize: function () {
        KMVP.masterCarts.bindNewMasterCartBtnPDP();
        KMVP.masterCarts.bindNewMasterCartBtn();
        KMVP.masterCarts.bindDeleteMasterCartLink();
        KMVP.masterCarts.bindUpdateMasterCartLink();
        KMVP.masterCarts.bindMasterCartApproveBtn();
        KMVP.masterCarts.bindMasterCartEditBtn();
        KMVP.masterCarts.bindMoveCartEntryToQuoteRequest();
        KMVP.masterCarts.bindCartDropDown();
        KMVP.masterCarts.bindCopyCartEntriesToQuoteRequest();
        KMVP.masterCarts.bindRequestPricesButton();
        KMVP.masterCarts.checkAndTriggerCartCalculationOnSummaryPage();
    }
};

$(document).ready(function () {
    KMVP.masterCarts.initialize();
});